export const environment = {
    production: true,
    hRef: '/',
    ajuaCode: 'TIH9DB',
    mileleUser: 'MileleTrust',
    milelePass: '#Trusted@pas!3022%',

    appID: 'mileleUser',
    appPass: '66335231',
    channelID: 1,

    siteURL: 'https://mileletrust.icealion.com',
    // baseUrl: 'https://trustpilotapi.icealion.com',
    baseUrl: 'https://mileletrustapi-cloud.icealion.com/api',
    // baseUrl: 'https://mileletrustapi.icealion.com:8245', // old prod

    medicalURL: 'https://mileletrust.icealion.com/medical-trust',
    // baseUrl: 'https://pilot-mileletrustapi.icealion.com', // IBM
    consentUrl: 'https://clientapi-cloud.icealion.com/consent-microsite/assets/js/embed.js',
    
    SentryDSN: 'https://475ef38e0500321d9dd591bbe1f86aba@o4504649314140160.ingest.sentry.io/4506269016850432'
};
